<template>
  <v-container fluid>
    <v-img :src="errorImage"></v-img>
    <v-row>
      <v-col cols="12">
        <p class="titleSizeErrorPage">
          {{ pageNotFound }}
        </p>
        <p class="textInputSizeErrorPage">
          {{ $t('error.ingresandoEspere') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      errorImage: '/errorImage.jpg',
      pageNotFound: ''
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 20px;
}
</style>
